import React, { useState, useEffect } from 'react';
import NavbarMex from '../components/navbarMex';
import './recargas.css';

const Recargas = () => {
    const [previewImage, setPreviewImage] = useState(null);
    const [monto, setMonto] = useState('');
    const [recargas, setRecargas] = useState([]);
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState('');
    const [currentDate, setCurrentDate] = useState(new Date().toLocaleDateString());

    useEffect(() => {
        const userId = localStorage.getItem('usuario_id');
        if (userId) {
            fetchRecargas(userId);
        }
    }, []);

    const fetchRecargas = async (userId) => {
        try {
            const response = await fetch(`https://api.99envios.app/api/online/recargas/ver-recargas-sucursal/${userId}`);
            const data = await response.json();
            setRecargas(data);
        } catch (error) {
            console.error('Error fetching recargas:', error);
        }
    };

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setPreviewImage(reader.result);
            };
            reader.readAsDataURL(file);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setMessage('');

        const fileInput = document.getElementById('foto-transaccion');
        if (!fileInput.files[0]) {
            setMessage('Por favor seleccione un comprobante');
            setLoading(false);
            return;
        }

        const formData = new FormData();
        formData.append('monto', monto);
        formData.append('comprobante', fileInput.files[0]);

        try {
            const userId = localStorage.getItem('usuario_id');
            const response = await fetch(`https://api.99envios.app/api/online/recargas/realizar-recarga/${userId}`, {
                method: 'POST',
                body: formData
            });

            if (!response.ok) throw new Error('Error al enviar la recarga');

            const data = await response.json();
            setMessage('Recarga enviada exitosamente');
            setMonto('');
            setPreviewImage(null);
            fetchRecargas(userId); // Refresh table data
        } catch (error) {
            setMessage('Error al enviar la recarga: ' + error.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <NavbarMex title={'Recargas'} />
            <div className="recargas-center">
                <div className="recargas-container">
                    <section className="recargas-section">
                        <h2>RECARGA TU CUENTA</h2>
                        <strong><p className="current-date">Fecha: {currentDate}</p></strong>
                        <p>Para recargar tu cuenta solo debes realizar una transferencia o consignación a nuestra cuenta Bancolombia con los siguientes datos:</p>
                        
                        <ul className="recargas-account-info">
                            <li>I Love Group sas</li>
                            <li>Nit: 901217397-1</li>
                            <li>Cuenta de Ahorros</li>
                            <li>Numero: 46700012263</li>
                            <li>Bancolombia</li>
                        </ul>

                        <p>Después de realizar el envío del dinero envíanos el soporte de la transacción con tu código de sucursal, tu nuevo saldo se verá reflejado en tu cuenta de 1 a 2 días hábiles.</p>
                        
                        <form className="recargas-form" onSubmit={handleSubmit}>
                            <div className="recargas-input-row">
                                <div className="recargas-input-group" style={{ maxWidth: '300px' }}>
                                    <label htmlFor="monto" style={{ marginBottom: '0px' }}>Monto de Recarga</label>
                                    <input 
                                        type="number" 
                                        id="monto" 
                                        name="monto" 
                                        value={monto}
                                        onChange={(e) => setMonto(e.target.value)}
                                        required 
                                        placeholder="Ingrese el monto"
                                    />
                                </div>
                            </div>
                            
                            <label htmlFor="foto-transaccion">Foto transacción</label>
                            <div className="file-upload-container">
                                {previewImage && (
                                    <img 
                                        src={previewImage} 
                                        alt="Vista previa" 
                                        className="file-preview"
                                    />
                                )}
                                <p className="file-upload-text">
                                    {previewImage ? 'Click para cambiar la imagen' : 'Click para seleccionar una imagen'}
                                </p>
                                <label className="file-upload-button" htmlFor="foto-transaccion">
                                    Seleccionar archivo
                                </label>
                                <input 
                                    type="file" 
                                    id="foto-transaccion" 
                                    name="foto-transaccion" 
                                    accept="image/*" 
                                    required 
                                    onChange={handleFileChange}
                                />
                            </div>
                            
                            {message && (
                                <div className={`recargas-message ${message.includes('Error') ? 'error' : 'success'}`}>
                                    {message}
                                </div>
                            )}
                            
                            <button 
                                type="submit" 
                                className="recargas-button"
                                disabled={loading}
                            >
                                {loading ? 'Enviando...' : 'Enviar comprobante'}
                            </button>
                        </form>
                    </section>

                    <section className="recargas-history">
                        <h2>Historial de Recargas</h2>
                        <div className="recargas-table-container">
                            <table className="recargas-table">
                                <thead>
                                    <tr>
                                        <th>ID</th>
                                        <th>Fecha</th>
                                        <th>Monto</th>
                                        <th>Estado</th>
                                        <th>Tipo</th>
                                        <th>Comprobante</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {recargas.map((recarga) => (
                                        <tr key={recarga.id}>
                                            <td>{recarga.id}</td>
                                            <td>{recarga.fecha_recarga ? new Date(recarga.fecha_recarga).toLocaleDateString() : 'Pendiente'}</td>
                                            <td>${recarga.valor}</td>
                                            <td>{recarga.estado}</td>
                                            <td>{recarga.tipo_recarga}</td>
                                            <td>
                                                {recarga.comprobante && (
                                                    <a href={recarga.comprobante} target="_blank" rel="noopener noreferrer">
                                                        Ver comprobante
                                                    </a>
                                                )}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </section>
                </div>
            </div>
        </>
    );
};

export default Recargas;
